module.exports = __webpack_public_path__ + "media/images/logo-5edb8ce250628e74e1b10ab208b3b386.png";